import React from "react";
import LoginForm from "./LoginForm";

function Login({ setUser }) {
  return <LoginForm setUser={setUser} />;
}

export default Login;
